import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Home.css';

import slider1 from '../../image/car.png';
import slider2 from '../../image/car-2.png'
import SingleProduct from './SingleProduct/SingleProduct';

const HOME = () => {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        fetch('../products.json')
            .then(res => res.json())
            .then(data => {
                setProducts(data);
            });
    }, []);

    return (
        <div>
            <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
                </div>
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <img src={slider1} class="d-block w-100" alt="" />
                        <div class="carousel-caption d-none d-md-block">
                            <div className="slider-info">
                                <h1>POWER & BEAUTY</h1>
                                <p>Free Library’s $1M auto archives are moving to Philly’s world-famous car museum and to a Hershey attraction</p>
                                <div>
                                    <NavLink className="slider-btn" to="/shop">Discover Today</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <img src={slider2} class="d-block w-100" alt="..." />
                        <div class="carousel-caption d-none d-md-block">
                            <div className="slider-info">
                                <h1>POWER & BEAUTY</h1>
                                <p>Free Library’s $1M auto archives are moving to Philly’s world-famous car museum and to a Hershey attraction</p>
                                <div>
                                    <NavLink className="slider-btn" to="/shop">Discover Today</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
            <div className="container">
                <div class="container py-5">
                    <h2 className="span-text align-left pb-2">New Car</h2>
                    <h4 className="pb-2">Awesome Class Model</h4>
                    <div class="row row-cols-1 row-cols-md-4 g-3">
                        {
                            products.map(product => <SingleProduct
                                key={product.key}
                                product={product}
                            >
                            </SingleProduct>)
                        }
                    </div>
                </div>
            </div>
            <div className="container">
                <div class="row text-info">
                    <div class="col bg-danger text-white text">
                        <h3>Buy and Sale Vehiclese</h3>
                        <p>We buy and sale barand new car and also used car of any brand</p>
                    </div>
                    <div class="col bg-primary text-white text">
                        <h3>Vehicles Rental Service</h3>
                        <p>We buy and sale barand new car and also used car of any brand</p>
                    </div>
                    <div class="col bg-success text-white text">
                        <h3>Vehicles Servicing</h3>
                        <p>We buy and sale barand new car and also used car of any brand</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HOME;